import $ from 'jquery'
import { domready } from './domready'

domready(() => {
  document.querySelectorAll('.js-field-manage').forEach(mountComponent)
})

function mountComponent(el: Element) {
  const FIELD_ROW_SELECTOR = '.js-field-manage-row'
  const FIELD_ADD_BTN_SELECTOR = '.js-field-manage-add'
  const FIELD_REMOVE_BTN_SELECTOR = '.js-field-manage-remove'

  const $component = $(el)
  const fieldLimit = $component.data('limit') || 15
  const maxAllowedUserInvites = $component.data('available-users-count') || null

  $component.on('click', FIELD_ADD_BTN_SELECTOR, handleAdd)
  $component.on('click', FIELD_REMOVE_BTN_SELECTOR, handleRemove)

  updateComponent()

  function updateComponent() {
    const $add = $component.find(FIELD_ADD_BTN_SELECTOR)
    const $remove = $component.find(FIELD_REMOVE_BTN_SELECTOR)
    const $rows = $component.find(FIELD_ROW_SELECTOR)

    // Hide the "remove" button if there's only one field
    $rows.length > 1
      ? $remove.removeClass('hidden')
      : $remove.addClass('hidden')

    $rows.length >= fieldLimit
      ? $add.addClass('hidden')
      : $add.removeClass('hidden')

    if (!maxAllowedUserInvites) {
      return
    }

    if ($rows.length >= maxAllowedUserInvites) {
      mountUserInviteTooltip($add)
    } else {
      unmountUserInviteTooltip($add)
    }
  }

  function handleAdd(this: Element, event: Event) {
    event.preventDefault()

    if ($(this).hasClass('is-disabled')) {
      return
    }

    // Clone the first field
    const $fieldRow = $component.find(FIELD_ROW_SELECTOR).first().clone()

    // Wipe the input value and remove the label
    $fieldRow.find('input').val('')
    $fieldRow.find('.c-form-row_label').text('')

    // Remove form errors
    $fieldRow.removeClass('error').find('.c-form-row_error').remove()
    $fieldRow.find('input').removeClass('is-invalid')

    // Append it and set focus
    $fieldRow
      .insertAfter($component.find(FIELD_ROW_SELECTOR).last())
      .find('input')
      .first()
      .focus()

    updateComponent()
  }

  function handleRemove(this: Element, event: Event) {
    event.preventDefault()

    // Clone the field label
    const $label = $component
      .find('.c-form-row')
      .first()
      .find('.c-form-row_label')
      .html()

    // Remove the field
    $(this).parents(FIELD_ROW_SELECTOR).remove()

    // Move the  label to the first field
    $component
      .find(FIELD_ROW_SELECTOR)
      .first()
      .find('.c-form-row_label')
      .html($label)

    updateComponent()
  }

  function mountUserInviteTooltip(addButton: JQuery) {
    addButton.removeClass('js-tooltip-disabled')
    addButton.addClass('is-disabled')
  }

  function unmountUserInviteTooltip(addButton: JQuery) {
    addButton.addClass('js-tooltip-disabled')
    addButton.removeClass('is-disabled')
  }
}
